import { useState } from 'react';
import { Row, Col } from "reactstrap";
import DownloadIcon from "../../assets/DownloadIcon";
import SafeIcon from "../../assets/SafeIcon";
import ThunderIcon from "../../assets/ThunderIcon";
import ButtonCommon from "../../components/ButtonCommon";
import HeadingMain from "../../components/Heading";
import InputCommon from "../../components/InputCommon";
import microValidator from 'micro-validator'
import CustomAlerts from '../../components/AlertCustom.js';
import { registerWithPhoneNumber, logout } from '../../api/onboarding';
import './index.scss'
import { SSO_auth_path } from '../../config';


let loginValidationSchema = {
  firstName: {
      required: {
          errorMsg: 'First name is required'
      }
  },
  lastName: {
      required: {
          errorMsg: 'Last name required'
      },
  },
  phoneNumber: {
    required: {
        errorMsg: 'Phone number is required'
    },
  },
  dob: {
    required: {
        errorMsg: 'DOB is required'
    },
  },
  email:{
    required: {
      errorMsg: 'Email is required'
      },
      email: {
        errorMsg: 'Email is not valid'
    }
  }
}


const MainContent = ({props}) => {
  const [form, setForm]         = useState({firstName: '', lastName: '', dob: '1992-06-25', phoneNumber: '', email:""});
  const [ error , setErrors ]   = useState({firstName: '', lastName: '', dob: '', phoneNumber: '', email:""});

  const onChange = (value, key) => {
    let currentForm = {...form};
    currentForm[key] = value.trim() != "" ? value : "";
    error[key] = ''
    setForm(currentForm);
    setErrors({ ...error })
  }

  const onSubmit = () => {
    const errorsHandler = microValidator.validate(loginValidationSchema, form)
    if (Object.keys(errorsHandler).length) {
        setErrors(errorsHandler)
        return
    }
    registerWithPhoneNumber(form).then(res => {
      props.history.push('/otp')
    }).catch((err) => {
      CustomAlerts({
          message : err?.data?.message,
          title:'Error',
          type:'danger'
      })
    })
  }

  const applyNow = () => {
    let stingToConvert = '/verification'
    const urlParams = new URLSearchParams(window.location.search);
    const partnerToken = urlParams.get('token');
    if (partnerToken) {
      stingToConvert += '?token='+partnerToken;
    }
    let redirectUrl = btoa(stingToConvert)
    //logout();

    window.location.href = `${SSO_auth_path}&return_path=${redirectUrl}`;
  }

  return (
    <section className="mainContent">
      <Row>
        <Col lg={6}>
          <div className="dataContainer">
            <HeadingMain text="GST PayLater" color="#1678FB" />
            <HeadingMain text="File on time, pay later" />
            <h3>
              A low interest credit line to make sure you never miss any GST payment deadline due to limited cashflow
            </h3>
            <div className="infoContaner">
              <p>
                Apply instantly, 100% digital
              </p>
            </div>
            <div className="infoContaner">
              <p>
                Starting @ 0.05% interest rate /day
              </p>
            </div>
            <div className="infoContaner">
              <p>
                Safe and secure
              </p>
            </div>
            <div className="homeBtns">
              <ButtonCommon title="Check Eligibility" onClick={() => applyNow()} />
              {/*<ButtonCommon title="Get Shareable Link" className="link" />*/}
            </div>
          </div>
        </Col>
        <Col lg={6} className="imgBox" >
          <img src="banner.png" />
        </Col>
      </Row>
    </section>
  )
}

export default MainContent;